'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface StageItem {
  number: string
  title: string
  description: string
}

const WorkStages: React.FC = () => {
  const stages: StageItem[] = [
    {
      number: '01',
      title: 'Аналитика',
      description: 'Исследуем ваш рынок, конкурентов и запросы аудитории. На основе данных строим стратегию и проверяем гипотезы, чтобы продукт был востребован и решал конкретные задачи вашего бизнеса.'
    },
    {
      number: '02',
      title: 'Проектирование',
      description: 'Создаём прототип продукта и детальные дизайн-макеты. Параллельно пишем подробное техническое задание, которое описывает логику работы каждой кнопки и функции.'
    },
    {
      number: '03',
      title: 'Разработка и тестирование',
      description: 'Переводим дизайн в код и выстраиваем надёжную архитектуру приложения. Проводим всестороннее тестирование, чтобы убедиться в стабильности, безопасности и высокой скорости работы продукта.'
    },
    {
      number: '04',
      title: 'Запуск и сопровождение',
      description: 'Публикуем проект и обеспечиваем техническую поддержку после релиза. Обучаем ваш персонал работе с системой, помогаем с техническими вопросами и сопровождаем продукт в процессе его роста.'
    }
  ]

  return (
    <section className={styles.workStages}>
      <div className={styles.container}>
        <div className={styles.content}>
          <AnimatedSection animation="slideUp">
            <div className={styles.subtitle}>Этапы работы</div>
            <h2 
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: '<span>От аналитики до сопровождения</span> продукта после запуска' }}
            />
          </AnimatedSection>
          
          <div className={styles.items}>
            {stages.map((item, index) => (
              <AnimatedSection key={index} animation="slideUp">
                <div className={styles.item}>
                  <div className={styles.itemHeader}>
                    <div className={styles.itemNumber}>{item.number}</div>
                    <h3 className={styles.itemTitle}>{item.title}</h3>
                  </div>
                  <p className={styles.itemDescription}>{item.description}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

WorkStages.displayName = 'WorkStages'

export default WorkStages